import Vue from 'vue'
import { $$ } from '../_utils'
import RequestHelper from '../_request-helper'

Vue.component('vue-cart-order-summary', {
  template: '#vue-cart-order-summary-template',
  props: ['prizes', 'user', 'link1', 'link2'],
  data() {
    return {}
  },
  mounted() {},
})

const summaries = $$('#vue-cart-order-summary-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!summaries) return
  summaries.forEach(element => {
    new Vue({
      el: element,
    })
  })

  let orderButton = document.getElementById('order-submit')
  document.addEventListener('click', function (e) {
    // first click
    if (orderButton && e.target.id === orderButton.id) {
      orderButton.onclick = function (event) {
        // second click
        event.preventDefault()
      }
    }
  })
})
